module.exports = __webpack_public_path__ + "static/img/wlaqpx.12add0c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wlaqpx.jpg
// module id = VMiG
// module chunks = 0